import React from "react";

const VideoModal = ({ videoId, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="video-modal" onClick={onClose}>
      <div
        className="video-modal__content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="video-modal__close" onClick={onClose}>
          ×
        </button>
        <iframe
          width="100%"
          height="100%"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default VideoModal;
